import { defineStore } from 'pinia'
import { useNuxtApp } from '#app'
import { Success } from '@/api/results'

/* Types */
import { StoreId } from '@/store'
import { PopupOfWorking } from '~/types/store'

export const useSlidersStore = defineStore({
  id: StoreId.SLIDERS,
  state: () => {
    return {
      isVisibleApplicationBanner: false,
      isVisibleCallbackForm: false,
      popupsOfWorking: {
        popups: null,
        visible: false,
        callPopup: null,
      } as PopupOfWorking,
      isVisiblePopupOfWorking: false,
    }
  },
  getters: {},
  actions: {
    setPopupWorking(popupsState: typeof this.popupsOfWorking) {
      Object.assign(this.popupsOfWorking, popupsState)
    },
    async fetchPopupsWorking(isBasket: boolean) {
      const { $apiService } = useNuxtApp()
      const result = await $apiService.site.getPopupWorking(isBasket)

      // проверяем что popups в наличии
      if (result instanceof Success && !!result.data.popups.length) {
        const { popups } = result.data

        this.setPopupWorking({
          ...this.popupsOfWorking,
          popups,
        })
      }
    },
  },
})
